var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoderun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758174494215,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 93685,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1006.98256 556.64c-4.192 4.208-9.232 6.784-14.192 9.472l-177.568 180.32a59.04 59.04 0 0 1-83.936 0 60 60 0 0 1 0-84.448l147.776-150.016-147.856-150.096a59.888 59.888 0 0 1 0-84.416 59.232 59.232 0 0 1 83.936 0l177.28 179.984c5.136 2.72 10.336 5.44 14.656 9.776 12.288 12.368 17.6 28.752 16.864 44.944 0.608 16.032-4.784 32.224-16.96 44.48zM321.31856 898.688L579.12656 125.312h128.896L450.21456 898.688h-128.896zM150.35856 511.952l152.432 152.432a61.408 61.408 0 0 1-86.816 86.848L32.71056 567.888c-5.296-2.8-10.64-5.568-15.104-10.016-12.592-12.608-18.16-29.264-17.536-45.744-0.768-16.64 4.72-33.504 17.44-46.224 4.592-4.592 10.08-7.488 15.568-10.336l182.96-182.992a61.504 61.504 0 0 1 86.832 0 61.376 61.376 0 0 1 0 86.816l-152.512 152.56z",
    "p-id": 93686
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoderun);
export default __webpack_public_path__ + "static/media/coderun.e9db0b7a.svg";
export { ForwardRef as ReactComponent };